import React from 'react';

class HoverInfo extends React.Component{

    render(){ 
        return (
            <div>
                <div id='hover-info' className='hover-info-container d-none'>
                    <div id='hover-tooltip-arrow' className='tooltip-arrow-left'>
                        <div></div>
                    </div>
                    <table className='hover-info-table'>
                        <tr>
                            <td id='hover-custom-level'></td>
                            <td id='hover-level-name'></td>
                        </tr>
                        <tr>
                            <td id='hover-custom-category'></td>
                            <td id='hover-category-name'></td>
                        </tr>
                        <tr className='d-none'>
                            <td id='hover-custom-appartment'></td>
                            <td id='hover-appartment-name'></td>
                        </tr>
                        <tr className='d-none'>
                            <td id='hover-custom-cost'>Costo</td>
                            <td id='hover-cost-name'></td>
                        </tr>
                        <tr className='d-none'>
                            <td id='hover-custom-quantity'>Cantidad</td>
                            <td id='hover-quantity-name'></td>
                        </tr>
                        <tr className='d-none'>
                            <td id='hover-custom-paid'>% Pagado</td>
                            <td id='hover-paid-name'></td>
                        </tr>
                        <tr className='d-none'>
                            <td id='hover-custom-start'></td>
                            <td id='hover-start-name'></td>
                        </tr>
                        <tr className='d-none'>
                            <td id='hover-custom-end'></td>
                            <td id='hover-end-name'></td>
                        </tr>
                    </table>
                </div>
            </div>
        );
    }
}

export default HoverInfo;